import React, { useMemo } from 'react';
import { sortRelatedGuidesBySortOrderFirst } from '../../../../../utils/applyMenuConfigChanges/addSortOrderProperty/sortBySortOrder';
import { GuideMarkdown } from './GuideMarkdown/GuideMarkdown';

interface GuidesMarkdownDisplayListProps {
  node: any;
  prefix: string;
}

export function GuidesMarkdownDisplayList({
  node,
  prefix,
}: GuidesMarkdownDisplayListProps) {
  const sortedNodeGuides = useMemo(() => {
    return (
      sortRelatedGuidesBySortOrderFirst(node?.data?.relatedGuides || []) || []
    ).filter((file) => !file.isExternalLink);
  }, [node]);

  return (
    <>
      {sortedNodeGuides.map((mdFile, i) => (
        <GuideMarkdown
          key={`guide-markdown-${prefix}-${i}`}
          mdFile={mdFile}
          prefix={prefix}
        />
      ))}
    </>
  );
}
